/* tslint:disable */
/* eslint-disable */
/**
 * rb-c3po-warehouse
 * API für die Verwaltung von Warenausgangsaufträgen, Artikeln, Chargen und Seriennummern
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RemoveSerialFromOutboundOrderItemRequest
 */
export interface RemoveSerialFromOutboundOrderItemRequest {
    /**
     * Seriennummer des Artikels
     * @type {string}
     * @memberof RemoveSerialFromOutboundOrderItemRequest
     */
    serialNumber: string;
}

/**
 * Check if a given object implements the RemoveSerialFromOutboundOrderItemRequest interface.
 */
export function instanceOfRemoveSerialFromOutboundOrderItemRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "serialNumber" in value;

    return isInstance;
}

export function RemoveSerialFromOutboundOrderItemRequestFromJSON(json: any): RemoveSerialFromOutboundOrderItemRequest {
    return RemoveSerialFromOutboundOrderItemRequestFromJSONTyped(json, false);
}

export function RemoveSerialFromOutboundOrderItemRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemoveSerialFromOutboundOrderItemRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'serialNumber': json['serialNumber'],
    };
}

export function RemoveSerialFromOutboundOrderItemRequestToJSON(value?: RemoveSerialFromOutboundOrderItemRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'serialNumber': value.serialNumber,
    };
}

